<!-- Start Footer Area -->
<section class="footer-area" *ngIf="loadingData">
    <div class="container placeholder-glow">
        <div class="row justify-content-center">
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <h3><span class="placeholder col-6"></span></h3>
                    <ul class="footer-contact-info" style="list-style: none; padding: 0;">
                        <li style="margin-bottom: 10px;"><span class="placeholder col-10" style="height: 20px;"></span></li>
                        <li style="margin-bottom: 10px;"><span class="placeholder col-10" style="height: 20px;"></span></li>
                        <li style="margin-bottom: 10px;"><span class="placeholder col-10" style="height: 20px;"></span></li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget pl-5">
                    <h3><span class="placeholder col-6"></span></h3>
                    <ul class="footer-quick-links" style="list-style: none; padding: 0;">
                        <li style="margin-bottom: 10px;"><span class="placeholder col-8" style="height: 20px;"></span></li>
                        <li style="margin-bottom: 10px;"><span class="placeholder col-8" style="height: 20px;"></span></li>
                        <li style="margin-bottom: 10px;"><span class="placeholder col-8" style="height: 20px;"></span></li>
                        <li style="margin-bottom: 10px;"><span class="placeholder col-8" style="height: 20px;"></span></li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget pl-5">
                    <h3><span class="placeholder col-6"></span></h3>
                    <div class="gmap_canvas">
                        <span class="placeholder col-12" style="height: 200px; width: 100%;"></span>
                    </div>
                </div>
            </div>
        </div>
        <div class="copyright-area mt-4">
            <div class="row align-items-center">
                <div class="col-lg-6 col-sm-6 col-md-6">
                    <span class="placeholder col-8" style="height: 20px;"></span>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="footer-area" *ngIf="!loadingData">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <h3>Contact Info</h3>
                    <ul class="footer-contact-info">
                        <li>
                            <i class="flaticon-phone-call"></i>
                            <span>Phone</span>
                            <!-- <a href="tel:+8801309108497">+8801309108497</a> <br> -->
                            <a [href]="'tel:' + mainData?.Phone">{{ mainData?.Phone }}</a>
                        </li>
                        <li>
                            <i class="flaticon-email"></i>
                            <span>E-MAIL</span>
                            <a [href]="'mailto:' + mainData?.Email"
                                >{{ mainData?.Email }}</a
                            >
                        </li>
                        <li>
                            <i class="fa-solid fa-map-location"></i>
                            <span>ADDRESS</span>
                            <a>{{ mainData?.Address }}</a>
                        </li>
                        <li></li>
                    </ul>
                </div>
                <!-- <div class="mapouter">
                    <div class="gmap_canvas">
                        <iframe
                            class="gmap_iframe"
                            width="100%"
                            frameborder="0"
                            scrolling="no"
                            marginheight="0"
                            marginwidth="0"
                            src="https://maps.google.com/maps?width=600&amp;height=400&amp;hl=en&amp;q=St. Gregory's High School & College&amp;t=&amp;z=15&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
                        ></iframe
                        ><a href="https://capcuttemplate.org/"
                            >Capcuttemplate.org</a
                        >
                    </div>
                </div> -->
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget pl-5">
                    <h3>Important Links</h3>
                    <ul class="footer-quick-links">
                        <li>
                            <a
                                href="http://www.moedu.gov.bd/"
                                target="_blank"
                                rel="noopener"
                                >Ministry Of Education</a
                            >
                        </li>
                        <li>
                            <a
                                href="https://www.dhakaeducationboard.gov.bd/"
                                target="_blank"
                                rel="noopener"
                                >Dhaka Board</a
                            >
                        </li>
                        <li>
                            <a
                                href="http://www.dpe.gov.bd/"
                                target="_blank"
                                rel="noopener"
                                >Directorate Of Primary Education</a
                            >
                        </li>
                        <li>
                            <a
                                href="http://www.ugc.gov.bd/"
                                target="_blank"
                                rel="noopener"
                                >University Grants Comission Of Bangladesh</a
                            >
                        </li>
                        <li>
                            <a
                                href="http://www.bteb.gov.bd/"
                                target="_blank"
                                rel="noopener"
                                >Technical Education Board</a
                            >
                        </li>
                        <li>
                            <a
                                href="http://deb108497.dhakaeducationboard.gov.bd/"
                                target="_blank"
                                rel="noopener"
                                >Our Government Website</a
                            >
                        </li>
                        <li>
                            <a
                                href="http://banbeis.gov.bd/new/"
                                target="_blank"
                                rel="noopener"
                                >Banbeis</a
                            >
                        </li>
                    </ul>
                </div>
            </div>

 <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget pl-5">
                    <h3>Google Map</h3>
                  <div class="gmap_canvas">
                        <iframe
                            *ngIf="mapUrl"
                            class="gmap_iframe"
                            width="100%"
                            frameborder="0"
                            scrolling="no"
                            marginheight="0"
                            marginwidth="0"
                            [src]="mapUrl"
                        ></iframe
                        >
                    </div>
                </div>
            </div>
        </div>
        <div class="copyright-area">
            <div class="row align-items-center">
                <div class="col-lg-6 col-sm-6 col-md-6">
                    <p>
                        Copyright @{{ currentYear }}
                        <a
                            href="https://deshuniversal.com/"
                            class="text-gray-600 ml-1"
                            target="_blank"
                            rel="noopener noreferrer"
                            >Desh Universal Pvt. Limited</a
                        >. All rights reserved
                    </p>
                </div>
                <!-- <div class="col-lg-6 col-sm-6 col-md-6">
                    <ul>
                        <li><a routerLink="/">Terms & Conditions</a></li>
                        <li><a routerLink="/">Privacy Policy</a></li>
                    </ul>
                </div> -->
            </div>
        </div>
    </div>
</section>
<!-- End Footer Area -->


